// import React, { useState } from 'react';
// import Layout from '../layout/Layout';
// import PageTransition from '../components/PageTransition';

// // Import the sub-components
// import ProfileDetails from './ProfileDetails';
// import SecuritySettings from './SecuritySettings';
// import NotificationSettings from './NotificationSettings';

// export default function Settings() {
//   const [activeTab, setActiveTab] = useState('profile');
//   const user = JSON.parse(localStorage.getItem('user'))?.data || {};

//   return (
//     <Layout>
//       <PageTransition>
//         <h3 className="fw-bold mb-4">Settings</h3>
//         <div className="card border-0 shadow-sm rounded-4 overflow-hidden">
//           <div className="row g-0">
//             {/* Sidebar Navigation */}
//             <div className="col-md-3 bg-light border-end py-3">
//               <nav className="nav flex-column gap-1 px-2">
//                 <button onClick={() => setActiveTab('profile')} className={`nav-link border-0 text-start rounded-3 py-2 ${activeTab === 'profile' ? 'bg-white shadow-sm fw-bold text-primary' : 'text-muted'}`}>
//                   <i className="fas fa-user-circle me-2"></i> My Profile
//                 </button>
//                 <button onClick={() => setActiveTab('security')} className={`nav-link border-0 text-start rounded-3 py-2 ${activeTab === 'security' ? 'bg-white shadow-sm fw-bold text-primary' : 'text-muted'}`}>
//                   <i className="fas fa-shield-alt me-2"></i> Security
//                 </button>
//                 <button onClick={() => setActiveTab('notifications')} className={`nav-link border-0 text-start rounded-3 py-2 ${activeTab === 'notifications' ? 'bg-white shadow-sm fw-bold text-primary' : 'text-muted'}`}>
//                   <i className="fas fa-bell me-2"></i> Notifications
//                 </button>
//               </nav>
//             </div>

//             {/* Content Area */}
//             <div className="col-md-9 bg-white p-4 p-md-5">
//               {activeTab === 'profile' && <ProfileDetails user={user} />}
//               {activeTab === 'security' && <SecuritySettings />}
//               {activeTab === 'notifications' && <NotificationSettings />}
//             </div>
//           </div>
//         </div>
//       </PageTransition>
//     </Layout>
//   );
// }


import React, { useState } from 'react';
import Layout from '../layout/Layout';
import PageTransition from '../components/PageTransition';

// Import the sub-components
import ProfileDetails from './ProfileDetails';
import SecuritySettings from './SecuritySettings';
import NotificationSettings from './NotificationSettings';
import { getStoredUser } from '../utilities/encryption';
import Swal from 'sweetalert2';

export default function Settings() {
  const [activeTab, setActiveTab] = useState('profile');
  //const user = JSON.parse(localStorage.getItem('user'))?.data || {};

  const user=getStoredUser().data

  // Navigation Items with Icons and Descriptions
  const menuItems = [
    { 
      id: 'profile', 
      title: 'Profile Information', 
      icon: 'bi-person-badge', 
      desc: 'Update your name and photo' 
    },
    { 
      id: 'security', 
      title: 'Security & Access', 
      icon: 'bi-shield-check', 
      desc: 'Manage passwords and 2FA' 
    },
    { 
      id: 'notifications', 
      title: 'Email Notifications', 
      icon: 'bi-envelope-paper', 
      desc: 'Configure what Swals you get' 
    }
  ];

  return (
    <Layout>
      <PageTransition>
        <div className="container-fluid py-4">
          
          {/* TOP BAR: BREADCRUMBS & TITLE */}
          <div className="mb-4">
          <h3 className="fw-bold mb-1"><span className="color-theme">Account Overview</span></h3>
            <p className="text-muted small">Configure your workspace and personal account preferences.</p>
          </div>

          <div className="card border-0 shadow-sm rounded-4 bg-white overflow-hidden">
            <div className="row g-0" style={{ minHeight: '650px' }}>
              
              {/* SIDEBAR NAVIGATION */}
              <div className="col-lg-3 bg-light-subtle border-end">
                <div className="p-4">
                  <h6 className="text-uppercase text-muted fw-bold x-small tracking-widest mb-4">Account Overview</h6>
                
                  
                  <nav className="nav flex-column gap-2">
                    {menuItems.map((item) => (
                      <button
                        key={item.id}
                        onClick={() => setActiveTab(item.id)}
                        className={`nav-link border-0 text-start rounded-3 p-3 transition-all d-flex align-items-center gap-3 ${
                          activeTab === item.id 
                            ? 'bg-white shadow-sm text-primary ring-1-primary' 
                            : 'text-secondary hover-bg-light'
                        }`}
                      >
                        <div className={`p-2 rounded-2 ${activeTab === item.id ? 'bg-primary text-white' : 'bg-light text-muted'}`}>
                          <i className={`bi ${item.icon} fs-5`}></i>
                        </div>
                        <div className="overflow-hidden">
                          <span className={`d-block small lh-1 ${activeTab === item.id ? 'fw-bold' : 'fw-semibold'}`}>
                            {item.title}
                          </span>
                          <span className="text-muted d-block mt-1" style={{ fontSize: '11px' }}>
                            {item.desc}
                          </span>
                        </div>
                      </button>
                    ))}
                  </nav>

                  {/* BOTTOM SIDEBAR CARD */}
                  <div className="mt-5 p-3 rounded-4 bg-primary-subtle border border-primary-fade d-none d-lg-block">
                     <p className="small fw-bold text-primary mb-1">Need Help?</p>
                     <p className="text-primary small mb-0 opacity-75" style={{ fontSize: '11px' }}>
                        Check our documentation for advanced settings and API configurations.
                     </p>
                  </div>
                </div>
              </div>

              {/* MAIN CONTENT AREA */}
              <div className="col-lg-9">
                <div className="p-4 p-md-5">
                  <div className="max-width-700">
                    <header className="mb-5">
                      <h2 className="fw-bold text-dark h4 mb-2">
                        {menuItems.find(i => i.id === activeTab)?.title}
                      </h2>
                      <p className="text-muted small">
                        Changes made here will be reflected across all your connected devices.
                      </p>
                    </header>

                    {/* DYNAMIC COMPONENT LOADER */}
                    <div className="tab-pane-fade-in">
                      {activeTab === 'profile' && <ProfileDetails user={user} />}
                      {activeTab === 'security' && <SecuritySettings />}
                      {activeTab === 'notifications' && <NotificationSettings />}
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </PageTransition>
    </Layout>
  );
}